import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";

const pipe = tokenDefinition({
    name: TokenName.PIPE,
    type: TokenType.DELIMITER,
    tokenMatcher: /^ *\| */,
    contentMatcher: /^ *\| */
});

class Pipe {

    constructor() {

    }

    consume(tokenIterator, nodeIterator) {

       if(this.isPipe(tokenIterator)) {
           nodeIterator.addClosedNode(
               new Node(NodeName.PIPE, tokenIterator.token().value, null, nodeIterator.currentParentNode).close()
           )

           tokenIterator.eatTokens(1)
       }
    }

    onEndOfMarkup(openNode) {
    }

    toHtml(node, toHtml, idProvider) {
        return ""
    }

    isPipe(tokenIterator) {
        return tokenIterator.token().name === TokenName.PIPE
    }

}

export {pipe, Pipe}